<template>
  <el-dropdown
    v-if="
      change && (status === 0 || status === 7 || status === 3 || status === 6)
    "
    :type="getStatus.color"
    @command="changeStatus"
    trigger="click"
    size="small"
    split-button
  >
    {{ getStatus.title }}
    <el-dropdown-menu slot="dropdown">
      <el-dropdown-item
        v-for="s in statusList"
        :key="s.value"
        :command="s.value"
      >
        <span :style="`color: ${s.color}`">{{ s.title }}</span>
      </el-dropdown-item>
    </el-dropdown-menu>
  </el-dropdown>
  <el-button v-else :type="getStatus.color" size="mini">
    {{ getStatus.title }}
  </el-button>
</template>
<script>
export default {
  props: ["status", "change"],
  data() {
    return {
      statuses: [
        {
          title: "Новая",
          value: 0,
          color: "warning"
        },
        {
          title: "Новая",
          value: 7,
          color: "warning"
        },
        {
          title: "Отменена",
          value: 1,
          color: "danger"
        },
        {
          title: "Создана",
          value: 2,
          color: "primary"
        },
        {
          title: "В работе",
          value: 3,
          color: "primary"
        },
        {
          title: "Завершена",
          value: 4,
          color: "success"
        },
        {
          title: "Закрыта",
          value: 5,
          color: "success"
        },
        {
          title: "Приостановлена",
          value: 6,
          color: "info"
        },
        // этот статус считается равнозначным Новой
        // {
        //   name: "Sended",
        //   title: "Отправлена",
        //   value: 7
        // },

        {
          title: "без статуса",
          value: null,
          color: "#000"
        }
      ]
    };
  },
  computed: {
    getStatus() {
      return (
        this.statuses.find(item => item.value === this.status) ||
        this.statuses[8]
      );
    },
    statusList() {
      switch (this.status) {
        case 0:
          return [
            {
              title: "Взять в работу",
              value: 3,
              color: "#409EFF"
            },
            {
              title: "Отменить",
              value: 1,
              color: "#F56C6C"
            }
          ];
        case 7:
          return [
            {
              title: "Взять в работу",
              value: 3,
              color: "#409EFF"
            },
            {
              title: "Отменить",
              value: 1,
              color: "#F56C6C"
            }
          ];
        case 3:
          return [
            {
              title: "Завершить",
              value: 4,
              color: "#67C23A"
            },
            {
              title: "Закрыть",
              value: 5,
              color: "#67C23A"
            },
            {
              title: "Приостановить",
              value: 6,
              color: "#909399"
            }
          ];
        case 6:
          return [
            {
              title: "Взять в работу",
              value: 3,
              color: "#409EFF"
            },
            {
              title: "Отменить",
              value: 1,
              color: "#F56C6C"
            }
          ];
        default:
          return [];
      }
    }
  },
  methods: {
    async changeStatus(status) {
      const data = {
        status,
        id: this.$route.params.id
      };
      try {
        await this.$store.dispatch("changeStatus", data);
        this.$emit("refresh");
      } catch (e) {
        this.error = this.$ErrorsMod(e);
      }
    }
  }
};
</script>

<style scoped>
::v-deep .el-button.el-button--text.el-button--mini {
  padding: 0;
  margin-left: 1em;
  color: #909399;
}
</style>
